export default "__VITE_ASSET__BspZUs6T__"